// ---------------------------------------------------------------------------
// Block Definition: flow
//
// Special container block — delegates to the 5-phase layout engine.
// No data extraction.  Horizontal or vertical direction with sizing modes
// (content, equal_max, proportional) and expand modes (share, none).
// ---------------------------------------------------------------------------

export const flowDef = {
  type: "flow",
  label: "Flow Layout",
  description: "Vertical or horizontal layout container with proportional sizing.",

  crystallizer: null, // flow has no data extraction

  renderer: null, // wired by ui/src/blockRegistryInit.js

  editor: {
    icon: "columns",
    category: "layout-container",
    defaultTemplate: { type: "flow", direction: "vertical", children: [] },
    configFields: [
      { name: "direction", type: "select", label: "Direction", options: ["vertical", "horizontal"], defaultValue: "vertical" },
      { name: "sizing", type: "select", label: "Sizing", options: ["content", "equal_max", "proportional"], defaultValue: "content" },
      { name: "expand", type: "select", label: "Expand excess", options: ["share", "none"], defaultValue: "share" },
      { name: "gap", type: "number", label: "Gap between children (px)" },
      { name: "padding_x", type: "number", label: "Horizontal padding (px)" },
      { name: "max_visible", type: "number", label: "Max visible children" },
    ],
  },
};
